module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summary-section",
    attrs: {
      "data-aos": _vm.isInternalView ? '' : 'fade-up',
      "data-aos-once": "true"
    }
  }, [_c('v-container', [_c('v-expansion-panels', {
    attrs: {
      "dark": "",
      "accordion": "",
      "multiple": ""
    },
    model: {
      value: (_vm.panel),
      callback: function($$v) {
        _vm.panel = $$v
      },
      expression: "panel"
    }
  }, [_c('v-expansion-panel', {
    attrs: {
      "expand": ""
    }
  }, [_c('v-expansion-panel-header', [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "color": "#212121"
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Reel Analysis Summary")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "primary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 4269816174)
  }) : _vm._e(), _vm._v(" "), (_vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": _vm.downloadSummary
    }
  }, [_c('i', {
    staticClass: "fas fa-download fa-lg",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Download"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isInternalView && _vm.showRequiredActions()) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('open-analysis')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-magic fa-lg",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "AI Analysis"
    }
  })]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card', {
    staticClass: "mx-auto",
    attrs: {
      "id": "reel-analysis-summary",
      "outlined": "",
      "color": "#000000"
    }
  }, [_c('v-card-text', [_c('div', [(_vm.groups.length > 0) ? _c('div', {
    staticClass: "group-filter-btns-right"
  }, [_c('div', {
    staticClass: "group-btns"
  }, _vm._l((_vm.groups), function(group) {
    return _c('v-btn', {
      key: group.groupID,
      class: ['group-btn', {
        'active-btn': _vm.selectedGroup === group.groupID
      }],
      staticStyle: {
        "margin-right": "8px",
        "color": "#212121"
      },
      attrs: {
        "color": _vm.selectedGroup === group.groupID ? 'orange' : '#fff',
        "depressed": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.selectedGroup = _vm.selectedGroup === group.groupID ? null : group.groupID
        }
      }
    }, [_vm._v("\n                      " + _vm._s(group.groupName || group.groupID) + "\n                    ")])
  }), 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right mb-2"
  }, [(_vm.editPostOrder) ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "warning",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.cancelPostOrder
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n                    Cancel\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.editPostOrder) ? _c('v-btn', {
    staticClass: "mr-2",
    attrs: {
      "color": "success",
      "dark": "",
      "small": ""
    },
    on: {
      "click": _vm.savePostOrder
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-content-save")]), _vm._v(" Save Changes\n                  ")], 1) : _vm._e()], 1), _vm._v(" "), _c('v-data-table', {
    directives: [{
      name: "sortable-data-table",
      rawName: "v-sortable-data-table"
    }],
    key: _vm.dataTableKey,
    staticClass: "elevation-15 report-summary-table",
    attrs: {
      "dark": "",
      "headers": _vm.computedHeaders,
      "items": _vm.filteredPosts,
      "item-key": "key",
      "items-per-page": -1,
      "custom-sort": _vm.customSort
    },
    on: {
      "sorted": _vm.handleDataTableDragDrop
    },
    scopedSlots: _vm._u([_vm._l((_vm.computedHeaders), function(h, index) {
      return {
        key: ("header." + (h.value)),
        fn: function(ref) {
          var header = ref.header;

          return [_c('legend-icon', {
            key: index,
            attrs: {
              "header": h
            }
          })]
        }
      }
    }), {
      key: "item.name",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "d-flex align-center"
        }, [_c('v-icon', {
          staticClass: "move-cursor",
          attrs: {
            "small": ""
          }
        }, [_vm._v("\n                        mdi-arrow-all\n                      ")]), _vm._v(" "), (_vm.isInternalView) ? _c('v-btn', {
          staticClass: "btn-reload",
          attrs: {
            "text": "",
            "x-small": "",
            "color": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.refreshReportInf(item.id)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": "",
            "small": ""
          }
        }, [_vm._v("\n                          mdi-reload\n                        ")])], 1) : _vm._e(), _vm._v(" "), _c('a', {
          staticClass: "caption",
          staticStyle: {
            "color": "#fff"
          },
          attrs: {
            "href": _vm.profileUrl(item),
            "target": "_blank",
            "rel": "noopener noreferrer"
          }
        }, [_vm._v("@" + _vm._s(item.profileHandle || item.name))])], 1)]
      }
    }, {
      key: "item.url",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-left"
        }, [_c('v-btn', {
          attrs: {
            "x-small": "",
            "text": "",
            "color": "secondary",
            "elevation": "0",
            "href": item.url,
            "target": '_blank'
          }
        }, [_vm._v("\n                        View\n                      ")])], 1)]
      }
    }, {
      key: "item.outreach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.outreach === 0 ? '-' : item.outreach)) + "\n                  ")]
      }
    }, {
      key: "item.likes",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.likes === 0 ? '-' : item.likes)) + "\n                  ")]
      }
    }, {
      key: "item.comments",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.comments === 0 ? '-' : item.comments)) + "\n                  ")]
      }
    }, {
      key: "item.saved",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.saved === 0 ? '-' : item.saved)) + "\n                  ")]
      }
    }, {
      key: "item.interactions",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.interactions === 0 ? '-' : item.interactions)) + "\n                  ")]
      }
    }, {
      key: "item.shares",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.shares === 0 ? '-' : item.shares)) + "\n                  ")]
      }
    }, {
      key: "item.views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.views === 0 ? '-' : item.views) + "\n                  ")]
      }
    }, {
      key: "item.reach",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.reach === 0 ? '-' : item.reach) + "\n                  ")]
      }
    }, {
      key: "item.impressions",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.impressions === 0 ? '-' : item.impressions) + "\n                  ")]
      }
    }, {
      key: "item.plays",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.plays === 0 ? '-' : _vm.showPlayTime(item.plays)) + "\n                  ")]
      }
    }, {
      key: "item.watches",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.watches === 0 ? '-' : item.watches) + "\n                  ")]
      }
    }, {
      key: "item.new_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n                      " + _vm._s(item.new_engagement_rate === 0 ? '0' : item.new_engagement_rate) + " %\n                    ")])]
      }
    }, {
      key: "item.new_engagement_rate_view",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n                      " + _vm._s(item.new_engagement_rate_view === 0 ? '0' : item.new_engagement_rate_view) + " %\n                    ")])]
      }
    }, {
      key: "item.interaction_rate_plays",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n                      " + _vm._s(item.interaction_rate_plays === 0 ? '0' : item.interaction_rate_plays) + " %\n                    ")])]
      }
    }, {
      key: "item.engagement_rate_reach",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n                      " + _vm._s(item.engagement_rate_reach === 0 ? '0' : item.engagement_rate_reach) + " %\n                    ")])]
      }
    }, {
      key: "item.engagement_rate_sd",
      fn: function(ref) {
        var item = ref.item;

        return [(item.engagement_rate_sd && item.engagement_rate_sd !== '0.00') ? _c('div', [_vm._v("\n                      " + _vm._s(item.engagement_rate_sd === null ? '-' : item.engagement_rate_sd + '%') + "\n                    ")]) : _c('div', [_c('v-icon', {
          attrs: {
            "small": "",
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Hidden"
          }
        }, [_vm._v("mdi-eye-off")])], 1)]
      }
    }, {
      key: "item.median_engagement_rate",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(item.median_engagement_rate === null ? '-' : item.median_engagement_rate + '%') + "\n                  ")]
      }
    }, {
      key: "item.avg_likes",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.avg_likes === null ? '-' : item.avg_likes)) + "\n                  ")]
      }
    }, {
      key: "item.avg_comments",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.avg_comments === null ? '-' : item.avg_comments)) + "\n                  ")]
      }
    }, {
      key: "item.avg_views",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.avg_views === null ? '-' : item.avg_views)) + "\n                  ")]
      }
    }, {
      key: "item.avg_reels_plays",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n                    " + _vm._s(_vm._f("thousandSeprator")(item.avg_reels_plays === null ? '-' : item.avg_reels_plays)) + "\n                  ")]
      }
    }], null, true)
  }, [_vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _vm._v(" "), _c('template', {
    slot: "body.append"
  }, [_c('tr', {
    staticStyle: {
      "font-weight": "500"
    }
  }, [_c('td', [_c('strong', [_vm._v("TOTAL")])]), _vm._v(" "), _vm._l((_vm.computedHeaders), function(header) {
    return [(header.value !== 'name') ? _c('td', {
      key: header.value
    }, [_c('strong', [(header.value === 'live_date') ? [_vm._v("-")] : (header.value === 'url') ? [_vm._v("-")] : (header.value === 'outreach') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalOutreach === 0 ? '-' : _vm.totalOutreach)))] : (header.value === 'reach') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalReach === 0 ? '-' : _vm.totalReach)))] : (header.value === 'impressions') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalImpressions === 0 ? '-' : _vm.totalImpressions)))] : (header.value === 'likes') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalLikes === 0 ? '-' : _vm.totalLikes)))] : (header.value === 'shares') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalShares === 0 ? '-' : _vm.totalShares)))] : (header.value === 'comments') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalComments === 0 ? '-' : _vm.totalComments)))] : (header.value === 'saved') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalSaved === 0 ? '-' : _vm.totalSaved)))] : (header.value === 'interactions') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalInteractions === 0 ? '-' : _vm.totalInteractions)))] : (header.value === 'views') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalViews == 0 ? '-' : _vm.totalViews)))] : (header.value === 'plays') ? [_vm._v(_vm._s(_vm.showPlayTime(_vm.totalPlayTime)))] : (header.value === 'watches') ? [_vm._v(_vm._s(_vm._f("thousandSeprator")(_vm.totalWatches == 0 ? '-' : _vm.totalWatches)))] : (header.value === 'new_engagement_rate') ? [_vm._v(_vm._s(_vm.totalEngagementRate) + "%")] : (header.value === 'new_engagement_rate_view') ? [_vm._v(_vm._s(_vm.totalEngagementRateView) + "%")] : (header.value === 'interaction_rate_plays') ? [_vm._v(_vm._s(_vm.totalInteractionRatePlays) + "%")] : (header.value === 'engagement_rate_reach') ? [_vm._v(_vm._s(_vm.totalEngagementRateReach) + "%")] : (header.value === 'engagement_rate_sd') ? [_vm._v(" - ")] : (header.value === 'median_engagement_rate') ? [_vm._v(" - ")] : (header.value === 'avg_likes') ? [_vm._v(" - ")] : (header.value === 'avg_comments') ? [_vm._v(" - ")] : (header.value === 'avg_views') ? [_vm._v(" - ")] : (header.value === 'avg_reels_plays') ? [_vm._v(" - ")] : _vm._e()], 2)]) : _vm._e()]
  })], 2)])], 2)], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Reel Analysis Summary",
      "items": _vm.tableColsItems,
      "isSort": true
    },
    on: {
      "updated": _vm.updatePostAnalysisStatus
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ec9308a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/ReelSummary.vue
// module id = 2223
// module chunks = 0